import { abortIfNotPermitted } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/outlet/outlet-list.vue'),
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "outlet" */ `@js/franchise_component/outlet/outlet-create.vue`),
        beforeEnter: (to, from, next) => {
            /*
            abortIfNotPermitted('franchise_manage_outlets', next);
            */

            abortIfNotPermitted('admin_manage_outlets', next);
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "outlet" */ `@js/franchise_component/outlet/outlet-show.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_manage_outlets', next);
        },
    },
    {
        path: '/edit/:id',
        component: () =>
            import(/* webpackChunkName: "outlet" */ `@js/franchise_component/outlet/outlet-edit.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_manage_outlets', next);
        },
    },
    {
        path: '/taxes/:id',
        component: () =>
            import(/* webpackChunkName: "outlet" */ `@js/franchise_component/outlet/outlet-tax-list.vue`),
        beforeEnter: (to, from, next) => {
            abortIfNotPermitted('franchise_manage_outlets', next);
        },
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/outlet.js